import { Box, Grid, MenuItem, Typography, WithStyles } from "@material-ui/core";
import { FormikProps } from "formik";
import React from "react";
import { PickupItemLocation, PickupItemLocations } from "../../model/PickupItemLocation";
import { TypedFormCbxField } from "../Common/FormCbxField";
import FormMetadataField from "../Common/FormMetadataField";
import FormSelectField from "../Common/FormSelectField";
import FormTextField from "../Common/FormTextField";
import { EditMode } from "./models";

interface IProps extends FormikProps<PickupItemLocation> {
	mode: EditMode;
}

const EditPickupLocationFormContent = (props: IProps & WithStyles) => {
	const render = (): JSX.Element => {
		const { values, classes } = props;

		return (
			<Grid container className={classes.root} spacing={2} style={{ width: "100%" }}>
				<Grid item xs={12}>
					<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
						{props.mode === "edit" && <TypedFormCbxField {...props} propName={"isArchived"} label="Arkiverad" />}
					</Box>
				</Grid>
				<Grid item xs={4}>
					<FormSelectField {...props} propName="type" label="Typ" valueGetter={() => values.type ?? ""}>
						{PickupItemLocations.map((x, idx) => {
							return (
								<MenuItem key={idx} value={x}>
									{x}
								</MenuItem>
							);
						})}
					</FormSelectField>
				</Grid>
				<Grid item xs={8}>
					<FormTextField {...props} propName="name" label="Namn" />
				</Grid>
				<Grid item xs={12}>
					<FormTextField {...props} propName="description" label="Beskrivning" />
				</Grid>
				<Grid item xs={12}>
					<FormMetadataField {...props} label="Metadata" />
				</Grid>
				<Grid item xs={12}>
					<FormTextField
						{...props}
						propName="messageTemplate"
						label="Meddelandemall (snabbmeddelanden)"
						multiline
						minRows={2}
						maxRows={5}
					/>
					<Typography variant="body2" color="textSecondary" component="div" style={{ marginTop: "0.5em" }}>
						<ul>
							<li>Varje ny rad blir en egen knapp.</li>
							<li>
								[button]...[/button] — Renderar innehållet som en snabbknapp och gör det möjligt att styla knappen för
								att göra den tydligare. Attribut:
								<ul>
									<li>color — Anger textfärg på knappen.</li>
									<li>backgroundColor — Anger bakgrundsfärg på knappen.</li>
									<li>ex: [button color="#ffffff" backgroundColor="#ff0000"]Small[/button]</li>
								</ul>
							</li>
							<li>[required]...[/required] — Grupperar snabbmeddelanden. Minst ett värde inom gruppen måste anges.</li>
						</ul>
					</Typography>
				</Grid>
			</Grid>
		);
	};

	return render();
};

export default EditPickupLocationFormContent;
